import React, { useRef, useEffect } from 'react';
import audioFile from '../static/audio/notify.mp3';
const MessageNotification = ({ playNotification }) => {
    const audioRef = useRef(null);

    useEffect(() => {
        const playAudio = () => {
            if (audioRef.current) {
                audioRef.current.play();
            }
        };

        // Call playAudio function to play audio based on some condition or event
        if (playNotification) {
            playAudio();
        }

        // Clean up: Pause audio when component unmounts
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reset audio to start position
            }
        };
    }, [playNotification]); // Empty dependency array ensures this effect runs only once

    return (
        <audio
            ref={audioRef}
            src={audioFile} // Replace with your audio URL
            style={{ display: 'none' }} // Hide the audio player element
        />
    );
};

export default MessageNotification;